export default "__VITE_ASSET__Cy4b71fB__$_?url__"